<template>
  <div class="landing-page">
    <div class="col align-bottom"> 
      <div class="text name"> {{name}} </div>
    </div>
    <div class="col vertical align-top"> 
      <div class="text profession"> {{profession}} </div>
    </div>

  </div>
</template>

<script>
export default {
  name: 'LandingPage',
  props: {
    msg: String
  },
  data(){
    return {
      name: 'João Ferreira',
      profession: 'Software Engineer',
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.landing-page{
  height: 100vh;
  color: white;
  margin: 0px;
  width: 100%;
  min-width: 100%;
  overflow: hidden;
  position: relative;
  background: url(https://i.imgur.com/4BmZXa5.png);
  background-position: center;
  background-repeat: no-repeat;
  background-size: cover;
  background-attachment: fixed;
}

.landing-page *{
  z-index: 2;
}

.landing-page::before{
  background-repeat: no-repeat;
  background-position: center;
  background-size: 100%;
  z-index: 1;
  width: 100%;
  background: linear-gradient(0deg, var(--dark-color) 10%, var(--dark-color2) 250%);
  content:'';
  height: 100%;
  position: absolute;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  opacity: 1.0;
}
.col{
  height: 50%;
  display: flex;
}
.vertical{
  flex-direction: column;
}
.text{
  width:100%;
}

.align-bottom{
  align-items: flex-end;
  display: flex;
}

.align-top{
  align-items: flex-start;
  display: flex;
}

.name{
  font-family: 'OpenSans';
  font-style: italic;
  font-weight: normal;
}

.profession{
  color: var(--second-color);
  font-family: 'OpenSans';
}


@media screen and (min-width:601px){
  .name{
    font-size: 5em;
  }
  .profession{
    font-size: 3.8em;
  }
}

@media screen and (max-width:601px){
  .name{
    font-size: 13vw;
  }
  .profession{
    font-size: 10vw;
  }
}



</style>
